import { Button, Col, Form, Input, Row, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import User from "models/user/user";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateUserPassword } from "redux/roles/userRoleSlice";
import { downloadEvent } from "utilities/generalUtility";
import {
  passwordMessage,
  passwordRegex,
  shortPasswordRegex,
} from "utilities/regexUtilities";

export default function ChangePassword({
  isUpdatePassword,
  setIsUpdatePassword,
  userData,
}) {
  const dispatch = useDispatch();
  const portalUser = User.getPortalUser();
  const [btnLoading, setBtnLoading] = useState(false);

  const [form1] = useForm();
  const handleResetPassword = async () => {
    try {
      setBtnLoading(true);
      const res = await User.forgotPassword(userData?.emailID);
      setBtnLoading(false);
      // await dispatch(
      //   User.loginCall(values.email, encryptedPass, values.remember)
      // );
      // redirectToUrl("/");
    } catch (error) {
      setBtnLoading(false);

      // setFieldErrorsFromServer(error, form, values);
    }
  };
  const handlePassword = async (values) => {
    if (values.currentPassword === values.newPassword) {
      message.error("New Password cannot be same to your Existing Password.");
      return;
    }
    const body = {
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    };
    dispatch(updateUserPassword(body));
    form1.resetFields();
    setIsUpdatePassword(!isUpdatePassword);
  };
  return !portalUser ? (
    <>
      <div className="account-change-password">
        <div className="acount-change-content">
          <h1>OOPS!</h1>
          <p>You are now logged in with your google account </p>
          <p>
            Please proceed with ‘Set Password’ button to set your password in
            RESOLVEit.
          </p>
          <Button
            type="primary"
            size="large"
            className="cancel"
            htmlType="submit"
            onClick={handleResetPassword}
            loading={btnLoading}
          >
            Set Password
          </Button>
        </div>
      </div>
    </>
  ) : (
    <Form
      disabled={!User.isUserctive()}
      layout="vertical"
      className="user-form"
      // ref={formRef}
      form={form1}
      // initialValues={{
      //   remember: true,
      // }}
      onFinish={handlePassword}
    >
      <Row gutter={23}>
        <Col xs={24}>
          <Form.Item
            label={
              <>
                <div className="acount-setting-label">Current Password</div>
              </>
            }
            name="currentPassword"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },

              {
                whitespace: true,
                message: "All spaces are not allowed",
              },
              {
                pattern: new RegExp(shortPasswordRegex),
                message:
                  "Password must be at least 8 characters and have one digit or a special character",
              },
            ]}
          >
            <Input.Password
              placeholder="Current Password"
              disabled={isUpdatePassword}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="New Password"
            name="newPassword"
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },

              {
                whitespace: true,
                message: "All spaces are not allowed",
              },
              {
                pattern: new RegExp(shortPasswordRegex),
                message:
                  "Password must be at least 8 characters and contain one digit or a special character",
              },
            ]}
          >
            <Input.Password
              placeholder="New Password"
              disabled={isUpdatePassword}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            // className="mb-0"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },

              {
                whitespace: true,
                message: "All spaces are not allowed",
              },
              {
                pattern: new RegExp(shortPasswordRegex),
                message:
                  "Password must be at least 8 characters and contain one digit or a special character",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("The two passwords that you entered do not match")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Confirm Password"
              disabled={isUpdatePassword}
            />
          </Form.Item>
        </Col>

        <Col xs={24} className="forms-button d-flex justify-content-end">
          {!isUpdatePassword && (
            <>
              <Form.Item className="mb-0">
                <Button
                  ghost
                  size="large"
                  className="cancel"
                  htmlType="submit"
                  disabled={isUpdatePassword}
                  onClick={() => setIsUpdatePassword(!isUpdatePassword)}
                >
                  Cancel
                </Button>
              </Form.Item>
              <Form.Item className="mb-0">
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  onClick={() => {
                    downloadEvent("EditPassword");
                  }}
                >
                  Save Changes
                </Button>
              </Form.Item>
            </>
          )}
          {isUpdatePassword && (
            <Form.Item className="mb-0">
              <Button
                disabled={!User.isUserctive()}
                // style={{ border: "#110B79 1px solid" }}
                // disabled={!isUpdate}
                size="large"
                onClick={() => setIsUpdatePassword(!isUpdatePassword)}
              >
                Edit
              </Button>
            </Form.Item>
          )}
        </Col>
      </Row>
    </Form>
  );
}
